import React from 'react'

const IconMessageEdit = () => {
  return (
    <svg width='24' height='25' viewBox='0 0 24 25' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <mask
        id='mask0_17084_59339'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='0'
        y='0'
        width='24'
        height='25'
      >
        <rect y='0.5' width='24' height='24' fill='#D9D9D9' />
      </mask>
      <g mask='url(#mask0_17084_59339)'>
        <path
          d='M6.19225 14.3077H8.81925L13.9538 9.173C14.0718 9.04867 14.1603 8.9115 14.2193 8.7615C14.2783 8.6115 14.3077 8.46408 14.3077 8.31925C14.3077 8.17442 14.2757 8.03208 14.2115 7.89225C14.1473 7.75258 14.0614 7.62058 13.9538 7.49625L13.0443 6.54625C12.9263 6.42825 12.7933 6.33975 12.6453 6.28075C12.4971 6.22175 12.3455 6.19225 12.1905 6.19225C12.0455 6.19225 11.898 6.22175 11.748 6.28075C11.598 6.33975 11.4608 6.42825 11.3365 6.54625L6.19225 11.6807V14.3077ZM7.3845 13.1155V12.1655L10.3713 9.17875L10.852 9.648L11.3115 10.1385L8.3345 13.1155H7.3845ZM10.852 9.648L11.3115 10.1385L10.3713 9.17875L10.852 9.648ZM11.4923 14.3077H17.8077V12.8077H12.9923L11.4923 14.3077ZM2.5 21.5385V4.80775C2.5 4.30258 2.675 3.875 3.025 3.525C3.375 3.175 3.80258 3 4.30775 3H19.6923C20.1974 3 20.625 3.175 20.975 3.525C21.325 3.875 21.5 4.30258 21.5 4.80775V16.1923C21.5 16.6974 21.325 17.125 20.975 17.475C20.625 17.825 20.1974 18 19.6923 18H6.0385L2.5 21.5385ZM5.4 16.5H19.6923C19.7693 16.5 19.8398 16.4679 19.9038 16.4038C19.9679 16.3398 20 16.2692 20 16.1923V4.80775C20 4.73075 19.9679 4.66025 19.9038 4.59625C19.8398 4.53208 19.7693 4.5 19.6923 4.5H4.30775C4.23075 4.5 4.16025 4.53208 4.09625 4.59625C4.03208 4.66025 4 4.73075 4 4.80775V17.8848L5.4 16.5Z'
          fill='#5B92D3'
        />
      </g>
    </svg>
  )
}

export default IconMessageEdit
